module.exports = __webpack_public_path__ + "img/金币.90215a7f.png";